import { getDay } from 'date-fns';

const getWeekDayIndex = (date: Date = new Date()): number => {
  const dateFnsIndex = getDay(date);
  return dateFnsIndex === 0 ? 6 : dateFnsIndex - 1;
};

export default getWeekDayIndex;
